import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const DateIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <circle className="icon" cx="28" cy="28" r="18" />
      <circle className="icon" cx="28" cy="28" r="12" />
    </SvgIcon>
  );
};

export default DateIcon;
